import { TeachersToolkitHowTo } from "./TeachersToolkit/TeachersToolkitHowTo/TeachersToolkitHowTo";
import { SolarSchoolsTheme } from "./utilities/Theme/theme";
import { ThemeProvider } from "@material-ui/core/styles";
import ReactDOM from "react-dom";
import React from "react";

const init = (api) => {
  const element = document.getElementById("teachers-toolkit-guide");

  if (!element) {
    return;
  }

  // build API URL from slug and URL
  // NOTE: Not ideal incase routing changes but it works
  document.title = `Teachers Toolkit - How To`;
  ReactDOM.render(
    <ThemeProvider theme={SolarSchoolsTheme}>
      <TeachersToolkitHowTo />
    </ThemeProvider>,
    element
  );
};

export default init;



// WEBPACK FOOTER //
// ./resources/assets/js/app/teachersToolkitGuide.js